<template>
  <div class="bg-white">
    <main>
      <div class="max-w-8xl mx-auto py-6 sm:px-6 lg:px-8">
        <section>
          <div class="container max-w-screen-xl mt-8 rounded-lg">
            <router-view></router-view>
          </div>
        </section>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'Onboard',
  data() {
    return {};
  },
  created() {
    // handle redirect and if there's stripe params, send to last step
    if (this.$route.query.code) {
      this.$router.push('/onboard/connect');
    }
  },
};
</script>
